import { sygnet } from './sygnet'
import { logo } from './logo'
import { logoNegative } from './logo-negative'

import {
  cibSkype,
  cibFacebook,
  cibTwitter,
  cibLinkedin,
  cibFlickr,
  cibTumblr,
  cibXing,
  cibGithub,
  cibStackoverflow,
  cibYoutube,
  cibDribbble,
  cibInstagram,
  cibPinterest,
  cibVk,
  cibYahoo,
  cibBehance,
  cibReddit,
  cibVimeo,
  cibCcMastercard,
  cibCcVisa,
  cibStripe,
  cibPaypal,
  cibGooglePay,
  cibCcAmex,
  cibGumtree,
  cilExitToApp,
  cilAirplaneMode,
  cilBirthdayCake,
  cilFlower,
} from '@coreui/icons'
import {
  cifUs,
  cifBr,
  cifIn,
  cifFr,
  cifEs,
  cifPl
} from '@coreui/icons'
import {
  cilAlignCenter,
  cilAlignLeft,
  cilAlignRight,
  cilApplicationsSettings,
  cilArrowRight,
  cilArrowLeft,
  cilArrowThickRight,
  cilArrowTop,
  cilAsterisk,
  cilBan,
  cilBank,
  cilBasket,
  cilBell,
  cilBold,
  cilBookmark,
  cilCalculator,
  cilCalendar,
  cilCloudDownload,
  cilCopy,
  cilChartPie,
  cilCheck,
  cilCheckAlt,
  cilChevronBottom,
  cilChevronLeft,
  cilChevronRight,
  cilChevronTop,
  cilCircle,
  cilCheckCircle,
  cilClock,
  cilCode,
  cilCog,
  cilCommentSquare,
  cilCreditCard,
  cilCursor,
  cilCursorMove,
  cilDrop,
  cilDollar,  
  cilEnvelopeClosed,
  cilEnvelopeLetter,
  cilEnvelopeOpen,
  cilEuro,
  cilGlobeAlt,
  cilGrid,
  cilFile,
  cilFullscreen,
  cilFullscreenExit,
  cilGraph,
  cilHome,
  cilHistory,
  cilInbox,
  cilIndentDecrease,
  cilIndentIncrease,
  cilIndustry,
  cilInfo,
  
  cilInputPower,
  cilItalic,
  cilJustifyCenter,
  cilJustifyLeft,
  cilLaptop,
  cilLayers,
  cilLightbulb,
  cilList,
  cilLink,
  cilListNumbered,
  cilListRich,
  cilLocationPin,
  cilLockLocked,
  cilLockUnlocked,
  cilMagnifyingGlass,
  cilMap,
  cilMoon,
  cilNotes,
  cilFilter,
  cilOptions,
  cilPaperclip,
  cilPaperPlane,
  cilPencil,
  cilPeople,
  cilPhone,
  cilPrint,
  cilPuzzle,
  cilRoom,
  cilSave,
  cilScrubber,
  cilSettings,
  cilShare,
  cilShareAll,
  cilShareBoxed,
  cilShieldAlt,
  cilSpeech,
  cilSpeedometer,
  cilSpreadsheet,
  cilStar,
  cilSun,
  cilTags,
  cilTask,  
  cilTrash,
  cilUnderline,
  cilUser,
  cilUserFemale,
  cilUserFollow,
  cilUserUnfollow,
  cilX,
  cilXCircle,
  cilWarning,
  cilLevelUp,
  cilSearch,
  cilMove,
  cilCalendarCheck,
  cilChartLine,

  cilLibraryBuilding,
} from '@coreui/icons'
 
import {  
  cilEye,
  cilEyeSlash,
  cilTerrain,
  cilBuildingBusiness,
  cilBellRing,
  cilBellSlash,
  cilAlarm,
  cilAlarmOff,
  cilAlarmSnooze,
  cilChevronBottomAlt,
  cilChevronDoubleLeftAlt,
  cilChevronDoubleRightAlt,
  cilChevronTopAlt,
  cilCloudUpload,
  cilImage,
  cisArrowThickToLeft,
  cisArrowThickToRight,
  cilDocument,
  cilLibraryBooks,
  cilQueueRemove,
  cilCommentBubbleQuestion,
  cilFileExcel,
  cilUniversalAccess,
  cilFileAdd,
  cilMinusSquare,
  cilPlusSquare,
  cilContacts,
  cilShieldCheck,
  cilCalendarToday,
  cilVericalSplit,
  cilCommentSquareCheck,
  cilEuroCircle,
  cilReplay,
  cilFindReplace,
  cilLockMinus,
  cilArrowThickToRight,
  cilArchive,
  cilRestore,
  cilChevronLeftAlt,
  cilChevronRightAlt,
  cilQueue,
  cilPage,
  cilNote,
  cilFlag,
  cisFlag,
  cidSync,
  cisFileExcel,
  cilHourglass,
  cilCommentBubbleExclamation,
  cilCommentBubbleEdit,
  cisHistory,
  cidHistory,
   
} from '@coreui/icons-pro'

export const icons = Object.assign({}, {
  sygnet,
  logo,
  logoNegative
}, {
  //cilChevronRight,
  cilAlignCenter,
  cilAlignLeft,
  cilAlignRight,
  cilApplicationsSettings,
  cilArrowRight,
  cilArrowLeft,
  cilArrowThickRight,
  cilArrowTop,
  cilAsterisk,
  cilBan,
  cilBank,
  cilBasket,
  cilBell,
  cilBold,
  cilBookmark,
  cilCalculator,
  cilCalendar,
  cilCloudDownload,
  cilCopy,
  cilChartPie,
  cilCheck,
  cilCheckAlt,
  cilChevronBottom,
  cilChevronLeft,
  cilChevronRight,
  cilChevronTop,  
  cilCircle,
  cilCheckCircle,
  cilClock,
  cilCode,
  cilCog,
  cilCommentSquare,
  cilCreditCard,
  cilCursor,
  cilCursorMove,
  cilDrop,
  cilDollar,
  cilDocument,
  cilLibraryBooks,
  cilEnvelopeClosed,
  cilEnvelopeLetter,
  cilEnvelopeOpen,
  cilEuro,
  cilGlobeAlt,
  cilGrid,
  cilFile,
  cilFullscreen,
  cilFullscreenExit,
  cilGraph,
  cilHome,
  cilHistory,
  cilInbox,
  cilIndentDecrease,
  cilIndentIncrease,
  cilIndustry,
  cilInfo,
  
  cilInputPower,
  cilItalic,
  cilJustifyCenter,
  cilJustifyLeft,
  cilLaptop,
  cilLayers,
  cilLightbulb,
  cilList,
  cilLink,
  cilListNumbered,
  cilListRich,
  cilLocationPin,
  cilLockLocked,
  cilLockUnlocked,
  cilMagnifyingGlass,
  cilMap,
  cilMoon,
  cilNotes,
  cilFilter,
  cilOptions,
  cilPaperclip,
  cilPaperPlane,
  cilPencil,
  cilPeople,
  cilPhone,
  cilPrint,
  cilPuzzle,
  cilRoom,
  cilSave,
  cilScrubber,
  cilSettings,
  cilShare,
  cilShareAll,
  cilShareBoxed,
  cilShieldAlt,
  cilSpeech,
  cilSpeedometer,
  cilSpreadsheet,
  cilStar,
  cilSun,
  cilTags,
  cilTask,
  cilTrash,
  cilUnderline,
  cilUser,
  cilUserFemale,
  cilUserFollow,
  cilUserUnfollow,
  cilX,
  cilLevelUp,
  cilXCircle,
  cilWarning,
  cilEyeSlash,  
  cilEye,  
  cilTerrain,
  cilBuildingBusiness,
  cilBellRing,
  cilBellSlash,
  cilAlarm,
  cilAlarmOff,
  cilAlarmSnooze,
  cilChevronBottomAlt,
  cilChevronDoubleLeftAlt,
  cilChevronDoubleRightAlt,
  cilChevronTopAlt,
  cilCloudUpload,
  cilImage,
  cisArrowThickToLeft,
  cisArrowThickToRight,
  cilQueueRemove,
  cilCommentBubbleQuestion,
  cilFileExcel,
  cilUniversalAccess,
  cilFileAdd,
  cilExitToApp,
  cilAirplaneMode,
  cilBirthdayCake,
  cilMinusSquare,
  cilPlusSquare,
  cilContacts,
  cilShieldCheck,
  cilCalendarToday,
  cilSearch,
  cilMove,
  cilCalendarCheck,
  cilHourglass,
  cilCommentBubbleExclamation,
  cilCommentBubbleEdit,
  cisHistory,
  cidHistory,
  cilFlower,
  cilChartLine,
  
  cilLibraryBuilding,

  cilLockMinus,
  cilArrowThickToRight,
}, {
  cifUs,
  cifBr,
  cifIn,
  cifFr,
  cifEs,
  cifPl,
}, {
  cibSkype,
  cibFacebook,
  cibTwitter,
  cibLinkedin,
  cibFlickr,
  cibTumblr,
  cibXing,
  cibGithub,
  cibStackoverflow,
  cibYoutube,
  cibDribbble,
  cibInstagram,
  cibPinterest,
  cibVk,
  cibYahoo,
  cibBehance,
  cibReddit,
  cibVimeo,
  cibCcMastercard,
  cibCcVisa,
  cibStripe,
  cibPaypal,
  cibGooglePay,
  cibCcAmex,
  cibGumtree,
  cilVericalSplit,
  cilCommentSquareCheck,
  cilEuroCircle,
  cilReplay,
  cilFindReplace,
  cilArchive,
  cilRestore,
  cilChevronLeftAlt,
  cilChevronRightAlt,
  cilQueue,
  cilPage,
  cilNote,
  cilFlag,
  cisFlag,
  cidSync,
  cisFileExcel,
})
